<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import auth from "@/api/auth";
import _ from "lodash";
import { clearLoginInfo } from "@/utils";

export default {
  data() {
    return {
      timer: ""
    };
  },
  methods: {
    check() {
      let vuexToken = this.$u.store.state.user.vuex_token;
      if (_.isEmpty(vuexToken)) {
        return;
      }
      auth
        .checkToken()
        .then(() => {})
        .catch(() => {
          this.$router.replace({ name: this.$u.routerConst.LOGIN });
          clearLoginInfo();
        });
    }
  },
  mounted() {
    //轮询检查token有效性
   // this.timer = setInterval(this.check, 10 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style></style>
